import { z } from 'zod';
import { appletDesignVersionConfigSchemaLatest } from './appletDesign.latest.zod';
import { updateDesign } from '@redviking/argonaut-util/src/mes/designMigrationUtil';

/**
 * this schema defines what can be **read** from the db, not necessarily what
 * can be saved.
 *
 * The preprocess is supposed to help with converting any outdated configs to the latest.
 * NOTE: This only works if it is not ambiguous how to update from one version to another.
 * If additional user input is required to update from one version to another then this function would ideal fail with an error message telling the user to go through UI to supply needed inputs
 */
export const appletDesignSchema = z.preprocess((unknownAppletConfig, ctx) => {
    try {
        return updateDesign(unknownAppletConfig);
    } catch (e) {
        ctx.addIssue({
            fatal: true,
            code: 'custom',
            message: e instanceof Error ? e.message : `unknown error - ${JSON.stringify(e)}`,
        });
    }
}, appletDesignVersionConfigSchemaLatest);

export type AppletDesignConfig = z.infer<typeof appletDesignSchema>;
